export default "__VITE_ASSET__bd89a359__"